export const IzipayErrors = {
    INVALID_CREDENTIALS : {
        error: "Credenciales Invalidas"
    }
}